// import { h, Component } from 'preact';
import { h } from 'preact';
import * as categories from '../categories';

export default function connectToOneTrust(category, C) {
	return class OneTrustComponent extends C {
		constructor(props) {
			super(props);
			this.onOneTrustCategoriesChange = this.onOneTrustCategoriesChange.bind(this);
			this.state = this.state || {};
			this.onOneTrustCategoriesChange(categories.get());
		}

		componentDidMount(...args) {
			if (super.componentDidMount && typeof super.componentDidMount === 'function') {
				super.componentDidMount(...args);
			}
			categories.addChangeListener(this.onOneTrustCategoriesChange);
		}

		componentWillUnmount(...args) {
			if (super.componentDidMount && typeof super.componentWillUnmount === 'function') {
				super.componentWillUnmount(...args);
			}
			categories.removeChangeListener(this.onOneTrustCategoriesChange);
		}

		onOneTrustCategoriesChange(nextCategories) {
			let oneTrustCategories = [...nextCategories];
			let cat = typeof category === 'function' ? category(this.props, this.state) : category;
			let oneTrustAllowed = cat === true || categories.has(cat);
			this.setState({ oneTrustCategories, oneTrustAllowed });
		}
	};
}


// OLD VERSION FOR REFERENCE

// import { h, Component } from 'preact';
// import * as categories from './categories';
//
// export default function connectToOneTrust(category, C) {
// 	return class OneTrustComponent extends Component {
// 		constructor(props) {
// 			super(props);
// 			this.onCategoriesChange = this.onCategoriesChange.bind(this);
// 			this.state.categories = [...categories.get()];
// 		}
//
// 		componentDidMount() {
// 			categories.addChangeListener(this.onCategoriesChange);
// 		}
//
// 		componentWillUnmount() {
// 			categories.removeChangeListener(this.onCategoriesChange);
// 		}
//
// 		onCategoriesChange(nextCategories) {
// 			this.setState({
// 				categories: [...nextCategories],
// 			});
// 		}
//
// 		render() {
// 			return (
// 				<C
// 					{...this.props}
// 					oneTrustAllowed={categories.has(this.state.categories, category)}
// 				/>
// 			);
// 		}
// 	};
// }
